/*
Code for the Header on every Page
*/

import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useLocation } from "react-router-dom";
import logo from "./images/scripps_logo.png";

export const Header = () => {
  const location = useLocation();
  return (
    <div className="home-header">
      <Navbar expand="xl" className="full-width-navbar">
        <Container fluid>
          <div className="navbar-brand-container">
            <img src={logo} alt="Logo" className="navbar-logo" />
            <Navbar.Brand href="/" className="header1">
              Data Science at Scripps
            </Navbar.Brand>
          </div>
          <Navbar.Toggle aria-controls="offcanvasNavbar-expand-lg" />
          <Navbar.Offcanvas
            id="offcanvasNavbar-expand-lg"
            aria-labelledby="offcanvasNavbarLabel-expand-lg"
            placement="end"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title className="offcanvasNavbarLabel-expand-lg">
                Data Science at Scripps
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="justify-content-end flex-grow-1 pe-3">
                <Nav.Link
                  href="/courses"
                  className={
                    location.pathname === "/courses"
                      ? "active nav_text"
                      : "nav_text"
                  }
                >
                  {" "}
                  Courses
                </Nav.Link>
                <Nav.Link
                  href="/faculty"
                  className={
                    location.pathname === "/faculty"
                      ? "active nav_text"
                      : "nav_text"
                  }
                >
                  Faculty
                </Nav.Link>
                <Nav.Link
                  href="/resources"
                  className={
                    location.pathname === "/resources"
                      ? "active nav_text"
                      : "nav_text"
                  }
                >
                  5C Resources
                </Nav.Link>
                <Nav.Link
                  href="/careers"
                  className={
                    location.pathname === "/careers"
                      ? "active nav_text"
                      : "nav_text"
                  }
                >
                  Careers
                </Nav.Link>
                <Nav.Link
                  href="/faq"
                  className={
                    location.pathname === "/faq"
                      ? "active nav_text"
                      : "nav_text"
                  }
                >
                  FAQs
                </Nav.Link>
                <Nav.Link
                  href="/about"
                  className={
                    location.pathname === "/about"
                      ? "active nav_text"
                      : "nav_text"
                  }
                >
                  About
                </Nav.Link>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </div>
  );
};
